import * as React from 'react';
import { observer } from 'mobx-react';
import RetentionPolicyTagDisplay from 'owa-service/lib/contract/RetentionPolicyTagDisplay';
import { ObservableMap } from 'mobx';
import PolicyRow from './PolicyRow';

const styles = require('./RetentionPoliciesCommon.scss');

interface UserRetentionPolicyRowType extends RetentionPolicyTagDisplay {
    description: string;
    isChecked?: boolean;
}

interface RetentionPolicyListProps {
    policyList: ObservableMap<string, UserRetentionPolicyRowType>;
    policyIds: string[];
    isUserAtActivePolicies: boolean;
}

/**
 * This component renders the list of policy rows
 * @param props
 */
function RetentionPolicyList(props: RetentionPolicyListProps) {
    return (
        <div className={styles.policyRowsContainer}>
            {props.policyIds.map(index => {
                const policyInfo: UserRetentionPolicyRowType = props.policyList.get(index);
                const {
                    RetentionId,
                    DisplayName,
                    description,
                    OptionalTag,
                    isChecked,
                } = policyInfo;
                return (
                    <PolicyRow
                        key={RetentionId}
                        retentionId={RetentionId}
                        policyTitle={DisplayName}
                        policyDescription={description}
                        isUserAtActivePolicies={props.isUserAtActivePolicies}
                        isPolicyRemovable={OptionalTag}
                        isPolicyChecked={isChecked}
                    />
                );
            })}
        </div>
    );
}

export default observer(RetentionPolicyList);
